import React from "react";

// Deterministic, accessible initials avatar (e.g. "Jermaine Washington" → "JW")
// used as the fallback wherever a person has no profile picture. Replaces the
// old male/female silhouette so avatars look consistent across the app.

// DAP87 pastel palette, one colour per first initial (white letters stay
// readable on each).
const PALETTE = [
  "#6f8fd8",
  "#a77bd0",
  "#d27594",
  "#4e9ac0",
  "#7f9555",
  "#b0795a",
  "#5f9c96",
  "#c0766b",
];

const getInitials = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const colorFor = (name) => {
  const code =
    String(name || "")
      .trim()
      .toUpperCase()
      .charCodeAt(0) || 65;
  return PALETTE[Math.abs(code - 65) % PALETTE.length];
};

const InitialsAvatar = ({ name, size = 48, className = "" }) => (
  <span
    className={className}
    aria-hidden="true"
    style={{
      width: size,
      height: size,
      minWidth: size,
      borderRadius: "50%",
      backgroundColor: colorFor(name),
      color: "#ffffff",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      fontSize: Math.round(size * 0.4),
      lineHeight: 1,
      flex: "0 0 auto",
      textTransform: "uppercase",
      userSelect: "none",
    }}
  >
    {getInitials(name)}
  </span>
);

export default InitialsAvatar;
